import React from 'react';
import { fg } from '@atlaskit/platform-feature-flags';
import { AgentAvatar } from '@atlaskit/rovo-agent-components';
import { editorExperiment } from '@atlaskit/tmp-editor-statsig/experiments';
import { RovoAgentIcon } from '@atlassian/conversation-assistant-ui-components';
import { createAgentConfigItem } from '../../prebuilt/config-item-agents/create-agent-config-item';
import { PreloadModalComponent } from '../../ui/components/BrowseRovoAgentsModal/BrowseRovoAgentsModal';
import { createOpenAIModalCommand } from '../decoration/actions';
import { floatingToolbarAIDropdownTestIDPrefix } from '../floating-toolbar-button/floating-toolbar-button';
import { openBrowseAgentsModal } from './commands';
import { messages } from './messages';
export var getAgentsDropdown = function getAgentsDropdown(_ref) {
  var intl = _ref.intl,
    agents = _ref.agents,
    aiGlobalOptIn = _ref.aiGlobalOptIn,
    publish = _ref.publish,
    editorPluginAIProvider = _ref.editorPluginAIProvider;
  var options = (agents || []).map(function (agent, index) {
    var _agent$externalConfig;
    return {
      title: agent.name,
      testId: "".concat(floatingToolbarAIDropdownTestIDPrefix, "agent-").concat(agent.id),
      icon: editorExperiment('platform_editor_ai_command_palate_improvement', 'test') ? /*#__PURE__*/React.createElement(AgentAvatar, {
        agentId: agent.id,
        agentNamedId: (_agent$externalConfig = agent.externalConfigReference) !== null && _agent$externalConfig !== void 0 ? _agent$externalConfig : agent.namedId,
        label: agent.name,
        agentIdentityAccountId: agent.identityAccountId,
        isForgeAgent: agent.creatorType === 'FORGE',
        forgeAgentIconUrl: agent.icon
      }) : /*#__PURE__*/React.createElement(RovoAgentIcon, {
        label: agent.name
      }),
      onClick: function onClick(state, dispatch) {
        var openAIModalCommand = createOpenAIModalCommand({
          state: state,
          configItem: createAgentConfigItem('range', agent, editorPluginAIProvider),
          lastTriggeredFrom: 'floatingToolbarDropdown',
          // ED-18194 Added analytics for floating toolbar to determine
          // the % of users who click the button vs shift tab to it
          // triggerMethod: !didMouseEnter ? 'keyboard' : 'click',
          aiGlobalOptIn: aiGlobalOptIn
        });
        openAIModalCommand(state, dispatch);
        return false;
      }
    };
  });
  options.push({
    // FIXME: It's should not be a part of icon! It should be redone to hook!!!
    icon: editorPluginAIProvider.isRovoEnabled && /*#__PURE__*/React.createElement(PreloadModalComponent, null),
    title: intl.formatMessage(messages.agentsViewAgentsLabel),
    testId: "".concat(floatingToolbarAIDropdownTestIDPrefix, "view-all-agents"),
    onClick: function onClick(state, dispatch) {
      if (fg('rovo-chat-browse-agents')) {
        openBrowseAgentsModal(true)(state, dispatch);
      } else {
        publish({
          type: 'open-browse-agent-modal',
          source: 'editor'
        });
      }
      return false;
    }
  });
  return [{
    type: 'separator'
  }, {
    type: 'dropdown',
    testId: "".concat(floatingToolbarAIDropdownTestIDPrefix, "agents"),
    title: intl.formatMessage(messages.agentsDropdownTitle),
    options: options
  }];
};